import { defineMessages } from 'react-intl'

export default defineMessages({
  company: {
    id: 'containers.CustomerHomePage.company',
    defaultMessage: 'Company',
  },
  accountStatus: {
    id: 'containers.CustomerHomePage.accountStatus',
    defaultMessage: 'Account status',
  },
  onboarded: {
    id: 'containers.CustomerHomePage.onboarded',
    defaultMessage: 'Onboarded',
  },
  meetBranch: {
    id: 'containers.CustomerHomePage.meetBranch',
    defaultMessage: 'Meet your team',
  },
  branchMembers: {
    id: 'containers.CustomerHomePage.branchMembers',
    defaultMessage: 'and the rest of the team are here to help. They are the primary <i>task force</i> that will make sure your orders will run smooth. You can always reach out to any of us, if you have questions.',
  },
  latestNews: {
    id: 'containers.CustomerHomePage.latestNews',
    defaultMessage: 'We want to make sure you are updated with the latest news from VoiceArchive, so here it\'s the latest announcements relevant for  you.',
  },
  latestNewsTitle: {
    id: 'containers.CustomerHomePage.latestNews.title',
    defaultMessage: 'Announcements',
  },
  importantNotificationTitle: {
    id: 'containers.CustomerHomePage.importantNotificationTitle',
    defaultMessage: 'Important Notifications',
  },
  importantNotificationDismiss: {
    id: 'containers.CustomerHomePage.importantNotificationDismiss',
    defaultMessage: 'Dismiss',
  },
  sendEmail: {
    id: 'containers.CustomerHomePage.sendEmail',
    defaultMessage: 'Send e-mail',
  },
  call: {
    id: 'containers.CustomerHomePage.call',
    defaultMessage: 'Call',
  },
  connect: {
    id: 'containers.CustomerHomePage.connect',
    defaultMessage: 'Connect',
  },
  quickLinks: {
    id: 'containers.CustomerHomePage.quickLinks',
    defaultMessage: 'Quick links',
  },
  training: {
    id: 'containers.CustomerHomePage.training',
    defaultMessage: 'Go to the training module to explore quick guides, step-by-step instructions and short videos on how to use your dashboard.',
  },
  trainingTitle: {
    id: 'containers.CustomerHomePage.training.title',
    defaultMessage: 'Training',
  },
  template: {
    id: 'containers.CustomerHomePage.template',
    defaultMessage: 'Click here to grab the latest recommended template, for setting up manuscripts.',
  },
  templateHref: {
    id: 'containers.CustomerHomePage.template.href',
    defaultMessage: 'https://voicearchive-assets.s3.eu-central-1.amazonaws.com/voice-over-manuscript-template.docx',
  },
  templateTitle: {
    id: 'containers.CustomerHomePage.template.title',
    defaultMessage: 'Download manuscript template',
  },
  request: {
    id: 'containers.CustomerHomePage.request',
    defaultMessage: 'You can always reach out directly to your team above, or click here to reach out to our global production team.',
  },
  requestHref: {
    id: 'containers.CustomerHomePage.request.href',
    defaultMessage: 'mailto:mail@voicearchive.com',
  },
  requestTitle: {
    id: 'containers.CustomerHomePage.request.title',
    defaultMessage: 'Questions about orders, projects or deliveries?',
  },
  help: {
    id: 'containers.CustomerHomePage.help',
    defaultMessage: 'Click here to reach out to our technical support team.',
  },
  helpHref: {
    id: 'containers.CustomerHomePage.help.href',
    defaultMessage: 'mailto:support@voicearchive.com',
  },
  helpTitle: {
    id: 'containers.CustomerHomePage.help.title',
    defaultMessage: 'Need help?',
  },
  hello: {
    id: 'containers.CustomerHomePage.hello',
    defaultMessage: 'Hello, ',
  },
  addOrder: {
    id: 'containers.CustomerHomePage.addOrder',
    defaultMessage: 'Spot',
  },
  callToAction: {
    id: 'containers.CustomerHomePage.callToAction',
    defaultMessage: '+ New Project',
  },
  callToActionHref: {
    id: 'containers.CustomerHomePage.callToAction.href',
    defaultMessage: 'https://www.voicearchive.com/en/voicefinder?utm_source=voice-portal-dashboard',
  },
  callToActionSecondary: {
    id: 'containers.CustomerHomePage.callToAction.secondary',
    defaultMessage: 'Contact',
  },
  callToActionHrefSecondary: {
    id: 'containers.CustomerHomePage.callToAction.secondary.href',
    defaultMessage: 'https://www.voicearchive.com/en/contact?utm_source=voice-portal-dashboard',
  }
})
